import { TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

const TransitionFrame = styled(TransitionGroup)`
  width:100%;
  height:100%;
`;

export default TransitionFrame;